// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { DatePicker } from "@cofano/cck";
import { DatePickerBaseProps } from "@cofano/cck/DatePicker/DatePickerBase";
import moment from "moment";
import { useRef } from "react";

const TimePicker = ({
	value,
	onChange,
	...rest
}: Omit<DatePickerBaseProps, "value" | "onChange"> & {
	value?: number | null,
	onChange: (date: number | null) => void
}) => {
	const inputRef = useRef<HTMLInputElement | null>(null);
	const isFirstClick = useRef(true);

	const onSelectText = () => {
		if (value && isFirstClick.current) {
			inputRef.current?.select();
			isFirstClick.current = false;
		}
	};

	return (
		<DatePicker
			{...rest}
			inputRef={inputRef}
			onInputClick={onSelectText}
			value={(typeof value === "number") ? moment().startOf("day").add(value, "minutes").toDate() : null}
			onChange={(date) => {
				const startOfDay = moment().startOf("day");
				onChange(date ? moment(date).diff(startOfDay, "minutes") : null);
			}}
			onBlur={() => (isFirstClick.current = true)}
			portalId="date-picker-container"
			popperPlacement={"bottom-start"}
			showTimeSelect
			showTimeSelectOnly />
	);
};

export default TimePicker;
